export const URL_PARAMS = {
    PAGE: 'page',
    SIZE: 'per_page',
    SEARCH: 'search',
    SORT_DIRECTION: 'sort_direction',
    SORT_BY: 'sort_by',
};
